import { axiosInstance, QueryParams } from './req';
import { UserInfo } from '@/types/user-info';
import { Paginated } from '@/types/pagination';
import { userObj } from '@/utils/users';

export const loadCurrentUser = async (): Promise<{ user: UserInfo }> => {
    return axiosInstance.get('/api/users/me').then(({ data }) => data);
};

export const loadUsers = async ({ page, perPage, filter }: QueryParams): Promise<Paginated<UserInfo>> => {
    return axiosInstance.get('/api/v2/users', { params: { page, perPage, filter } }).then(({ data }) => data);
};

export const loadUser = async (): Promise<{ userDetails: UserInfo }> => {
    return axiosInstance.get('/api/users/me').then(({ data }) => {
        return {
            userDetails: userObj(data),
        };
    });
};

export const updateUser = async (user: Partial<UserInfo>): Promise<{ updatedUser?: UserInfo }> => {
    return axiosInstance.put(`/api/v2/users/me`, user).then(({ data }) => {
        return {
            updatedUser: userObj(data),
        };
    });
};

export const deleteUser = async (user: UserInfo): Promise<void> => {
    return axiosInstance.delete(`/api/users/${user._id}`).then(({ data }) => data);
};
